import { FilterStuffModel } from "@/views/loyalty/models/filter_stuff.model"

export class FilterStuff {
    constructor (data) {
        this.stuff = data || []
    }

    add (item) {
        this.stuff.push(item)
    }

    set (items) {
        this.stuff = items
    }

    get items () {
        return this.stuff
    }
}

export class FilterItem {
    constructor (data) {
        this.item = data || Object.create(FilterStuffModel)
        // console.log('class FilterItem this.item', this.item)
    }

    fieldKey (item) {
        this.item.fieldKey = item
        return this
    }

    fieldName (item) {
        this.item.fieldName = item
        return this
    }

    fieldValue (item) {
        this.item.fieldValue = item
        return this
    }

    fieldType (item) {
        this.item.fieldType = item
        return this
    }

    fieldValues (item) {
        this.item.fieldGroupValues = item
        return this
    }

    fieldMoney (min, max) {
        this.item.fieldMoney = Object.create({ min: min || null, max: max || null })
        return this
    }

    fieldDate () {
        this.item.fieldDate = Object.create({ disableFrom: true, from: null, disableTo: true, to: null, select: null })
        return this
    }

    fieldTitle (item) {
        this.item.fieldTitle = item
        return this
    }

    get value () {
        return this.item
    }
}

export function clearFilter (attrFilter, filter) {
    return attrFilter.map(f => {
        if (f.fieldTitle === filter.fieldTitle && (f.fieldType === 'text' || f.fieldType.includes('list'))) {
            return { ...f, fieldTitle: '', fieldValue: '' }
        } else if (f.fieldTitle === filter.fieldTitle && f.fieldType === 'money') {
            delete f.fieldMoney.min
            delete f.fieldMoney.max
            return { ...f, fieldTitle: '', fieldValue: '' }
        } else if (f.fieldTitle === filter.fieldTitle && f.fieldType === 'date') {
            delete f.fieldDate.from
            delete f.fieldDate.to
            delete f.fieldDate.select
            f.fieldDate.disableFrom = true
            f.fieldDate.disableTo = true
            return { ...f, fieldTitle: '', fieldValue: '' }
        } else {
            return f
        }
    })
}
